__turbopack_context__.v({
  "buttons": "LoginLogoutButton-module-scss-module__lDcXaq__buttons",
  "dropdownMenuItem": "LoginLogoutButton-module-scss-module__lDcXaq__dropdownMenuItem",
});
